package views.coletor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Notas
import ffMsgAviso
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import views.componentes.*

class col010 {

    private val _t = "col010"
    private var lista: List<Notas>? = null

    fun show() {

        ffMsgAviso("")
        lbTitulo!!.innerText = "010 - Agendamento"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
        }

    }

    @Composable
    fun body() {


        //table-responsive-sm
        Form(action = "#", attrs = { classes("table-responsive-sm"); onSubmit { it.preventDefault() } })
        {
            val _table1Controler = remember { mutableStateOf(gsInput(_t, _textAnt = "0")) }

            ffSpan("Recebimento de notas dos próximos 5 dias")

            if (_table1Controler.textAnt().equals("0"))
                produtoLote(_table1Controler)

            if (!_table1Controler.json().equals("")) {
                _table1Controler.textAnt("1")
                Div({ classes("table-responsive-sm") }) {
                    //println0("zuza999")
                    ff.println0(_table1Controler.json().equals(""))
                    //val o = lista.unsafeCast<Array<dynamic>>()
                    //println0(o)

                    val lcon = ArrayList<table1>()
                    lcon.add(table1().add(10, "S", "N", "NOT_NRNOTA       ", "Nota"))
                    lcon.add(table1().add(60, "L", "N", "OO_CLIENTE       ", "Fornecedor"))
                    lcon.add(table1().add(8 , "D", "N", "NOT_DTEMI        ", "Emissão"))
                    lcon.add(table1().add(12, "T", "N", "NOT_DTAGENDADO   ", "Agendado"))

                    table1().ffTable1(
                        lcon,
                        _table1Controler = _table1Controler,
                        _tbTipo = "Mesclado"
                    )
                    if (lista != null && _table1Controler.clickObj() >= 0) {
                        val onot = lista!!.get(_table1Controler.clickObj())
                        if (onot.NOT_OF != 0) {
                            principalCOL().ffNavePage("col002",onot.NOT_OF.toString())
                        }
                        //col001().show(sProduto)
                        _table1Controler.clickObjLimpar()
                    }


                }
                /*
                if (lista != null && _table1Controler.clickObj() >= 0) {
                    val onot = lista!!.get(_table1Controler.clickObj())
                    val sProduto = onot.PROLOT_PRODUTO.toString()
                    col001().show(sProduto)
                    _table1Controler.clickObjLimpar()
                }

                 */
            }

        }

    }

    fun produtoLote(_table1Controler: MutableState<String>) {

        val sSQL = Notas().queryAgendamento(5)

        Notas().getNotasSelect(sSQL) { _lista ->
            lista = _lista.distinctBy ({ p -> p.NOT_PEDCOM })
            for (obj in lista!!) {
                obj.OO_CLIENTE += "<br>Quantidade = " + obj.INOT_QTD00.ffVcRel(1) + " Número de itens = " + obj.OO_COUNT
                //obj.OO_CLIENTE = obj.OO_CLIENTE.split("#13").toString()
            }
            _table1Controler.json(JSON.stringify(lista).ffJsonParse(true))
            ff.println0(lista)
        }

    }

}